import { SuccessResponse } from '../../auth.types'

interface OrganizationSettingBase {
  display_name: string
  label: string
  description: string
  type: string
  group: string
  order: number
}

interface OrganizationEnforce2FaSetting extends OrganizationSettingBase {
  type: 'boolean'
  value: '0' | '1'
}

interface OrganizationRoleAuditIntervalDaysSetting
  extends OrganizationSettingBase {
  type: 'numeric'
  value: number
}

interface OrganizationSecuritySettings {
  'organization.enforce_2fa': OrganizationEnforce2FaSetting
  'organization.role_audit_interval_days': OrganizationRoleAuditIntervalDaysSetting
}

interface OrganizationSettingsSection {
  display_name: string
  icon: string
  settings: OrganizationSecuritySettings
}

interface OrganizationSettingsSections {
  security: OrganizationSettingsSection
}

interface OrganizationSettingsData {
  display_name: string
  icon: string
  sections: OrganizationSettingsSections
}

export type GetOrganizationSettingsResponse =
  SuccessResponse<OrganizationSettingsData>

export interface GetOrganizationSettingsRequest {
  module: string
}
